import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestSetPictures, requestSetDescrPdf } from './../../../../../../actions/sets';
import { getPictureUrlFromBase64 } from './../../../../../../utils/index';
import { createOrder } from './../../../../../../actions/firebase/orders';
import PrepareOrder from './../../../prepare-order';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Chip from 'material-ui/Chip';

const SetRow = ({
  orderSetId,
  set,
  createdOrder,
  pictures,
  //actions
  dispatch,
  requestSetPictures,
  requestSetDescrPdf,
  setOrderMode,
  removeOrderMode,
  sendOrder,
}) => {
  const style = {
    paddingBottom: '20px',
    width: '350px',
    marginLeft: '16px',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px'
  }

  let url = '';
  if (set.photo && set.photo.length > 0) {
    url = getPictureUrlFromBase64(pictures[set.photo[0]]);
  }

  const photoStyle = {
    display: 'flex',
    height: '200px',
    width: '330px',
    backgroundImage: 'url("' + url + '")',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  }

  const chipStyle = {
    background: 'rgb(245,245,245)',
    marginTop: '6px',
    marginLeft: '6px',
    height: '24px',
    display: 'flex',
    alignItems: 'center'
  }

  const chipLabelStyle = {
    fontSize: '13px',
    color: 'rgba(0,0,0,0.75)'
  }

  const propertiesKeys = Object.keys(set.properties || {});

  const getSetPropertyJsx = text => {
    return (
      <Chip key={text} style={chipStyle} labelStyle={chipLabelStyle}>
        {text}
      </Chip>
    )
  }

  return (
    <Paper style={style}>
      <div style={{color: 'rgb(245,245,245)', fontWeight: 'bold', padding: '10px', background: '#F44336', borderTopLeftRadius: '2px', borderTopRightRadius: '2px'}}>
        {set.title}
      </div>
      <div className='setRowItemPhoto' style={photoStyle}></div>
      <div style={{textDecoration: 'none', color: 'rgba(0,0,0, 0.67)', padding: '10px', paddingBottom: '16px', background: '#F44336', display: 'flex', flexWrap: 'wrap'}}>
        {propertiesKeys.map(key => getSetPropertyJsx(set.properties[key]))}
      </div>
      <div style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}} className='setBtns'>
        <RaisedButton
          label='Подробнее'
          labelStyle={{fontWeight: 'normal'}}
          onClick={
            () => {
              dispatch({ type: 'SET_SET', p: set.id });
              dispatch({ type: 'SET_SCREEN', name: 'setCard', val: true });
              dispatch(requestSetPictures());
              dispatch(requestSetDescrPdf());
            }
          }
        >
        </RaisedButton>
        {orderSetId !== set.id &&
          <RaisedButton
            label='Заказать'
            labelStyle={{fontWeight: 'normal'}}
            style={{marginLeft: '6px'}}
            onClick={
              () => {
                setOrderMode();
              }
            }
          >
          </RaisedButton>
        }
        {orderSetId === set.id &&
          <RaisedButton
            label='Отмена'
            labelStyle={{fontWeight: 'normal'}}
            style={{marginLeft: '6px'}}
            onClick={
              () => {
                removeOrderMode();
              }
            }
          >
          </RaisedButton>
        }
      </div>
      {orderSetId === set.id &&
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <PrepareOrder set={set} />
        </div>
      }
      {orderSetId === set.id &&
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <RaisedButton
            style={{marginTop: '8px'}}
            labelStyle={{fontWeight: 'normal'}}
            label='Отправить заказ'
            onClick={sendOrder}
          >
          </RaisedButton>
        </div>
      }
      {createdOrder &&
        <div style={{width: '100%', marginTop: '12px', display: 'flex', justifyContent: 'center' }}>
          <FlatButton
            label='Перейти к заказам'
            onClick={
              () => {
                dispatch({ type: 'SET_SCREEN', name: 'modelSets', val: false });
                dispatch({ type: 'SET_MAIN_SCREEN_PAGE', p: 'orders' });
              }
            }
          />
        </div>
      }
    </Paper>
  );
}

class SetRowContainer extends Component {
  constructor() {
    super();
    this.state = { createdOrder: false };
  }
  setOrderMode = () => {
    this.props.dispatch({ type: 'RESET_ORDER_CONDITIONS' });
    this.props.dispatch({ type: 'SET_ORDER_SET_ID', p: this.props.set.id });
  }
  removeOrderMode = () => {
    this.props.dispatch({ type: 'RESET_ORDER_CONDITIONS' });
    this.props.dispatch({ type: 'SET_ORDER_SET_ID', p: '' });
  }
  sendOrder = () => {
    this.props.dispatch(createOrder());
  }
  render () {
    const { createdOrder } = this.state;
    return (
      <SetRow
        {...this.props}
        setOrderMode={this.setOrderMode}
        removeOrderMode={this.removeOrderMode}
        sendOrder={this.sendOrder}
        createdOrder={createdOrder}
      />
    )
  }
}

export default connect(
  state => ({ pictures: state.pictures, orderSetId: state.ui.orderConditions.setId }),
  dispatch => ({ dispatch, requestSetPictures, requestSetDescrPdf, createOrder })
)(SetRowContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/list/item.js